import React, { useEffect, useState, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { Tooltip } from 'antd';
import exampleStore from '@/components/examples/store';
import "./index.scss"

const LabelList = observer(() => {
  return (
    <div className='flex justify-center h-36px gap-13px'>
      {
        exampleStore.data.tabList.slice(0, exampleStore.data.tabShowMaxIndex).map((item, index) => {
          return (
            <div 
              className={[
                'h-36px px-14px rounded-full box-border border-1px border-black border-opacity-16 leading-34px text-14px cursor-pointer',
                exampleStore.data.activeTab === item.category ? 'bg-black text-white font-bold hover:bg-[#333333]' : 'bg-white text-black hover:bg-[rgba(0,0,0,0.03)]'
              ]}
              onClick={() => {
                exampleStore.setData({
                  activeTab: item.category
                })
              }}
              key={index}
            >
              {item.title}
            </div>
          )
        })
      }
      <Tooltip 
        title={
          <div className='w-full h-full'>
            {
              exampleStore.data.tabList.slice(exampleStore.data.tabShowMaxIndex).map((item, index) => {
                return (
                  <div 
                    className={[
                      'w-full h-40px px-8px box-border leading-40px text-14px cursor-pointer text-black line-clamp-1 rounded-8px hover:bg-[rgba(0,0,0,0.04)]',
                      "text-left",
                      exampleStore.data.activeTab === item.category ? 'bg-[rgba(0,0,0,0.04)]' : ''
                    ]}
                    onClick={() => {
                      exampleStore.setData({
                        activeTab: item.category
                      })
                      exampleStore.exchange(exampleStore.data.tabShowMaxIndex - 1, index + exampleStore.data.tabShowMaxIndex);
                    }}
                    key={item.category}
                  >
                    {item.title}
                  </div>
                )
              })
            }
          </div>
        }
        getPopupContainer={node => node}
        placement="bottomRight"
        arrow={false}
      >
        <div 
          className={[
            'h-36px px-14px rounded-full box-border border-1px border-black border-opacity-16 leading-34px text-14px cursor-pointer bg-white example-more'
          ]}
        >
          更多
        </div>
      </Tooltip>
    </div>
  )
})

export default LabelList